import React from "react";
import { ConnectedGatewaysListContainer } from "../connected-gateways-list-container/connected-gateways-list-container";
import { GatewaysListHeader } from "@src/components/molecules/gateways-list-header/gateways-list-header";

export const GatewaysListsView = () => {

  return (
    <>
      <GatewaysListHeader />
      <ConnectedGatewaysListContainer />
      {/* <DisconnectedGatewaysListContainer /> */}
    </>
  );
};
